export default __webpack_public_path__ + "static/media/kabupaten-sragen.2f851291.png";